export default "__VITE_ASSET__f9162865__"